import React from "react";
import {cssArray, CSSType} from "../../utils";
import {root, rootFullWidth} from "./styles";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &{
    variant?: "primary"
    fullWidth?: boolean;
    overrideCss?: CSSType;
}

export const TextArea: React.FC<TextareaProps> = ({
                                                children,
                                                overrideCss,
                                                variant = "primary",
                                                fullWidth,
                                                ...rest
                                            }) => {
    return(
        <textarea css={[root, fullWidth && rootFullWidth, ...cssArray(overrideCss)]} {...rest}>
            {children}
        </textarea>
    )
}

export default TextArea;